import { isNumber, isString } from "lodash-es";

export type EnumValues<E extends Record<string, string | number>> = [E[keyof E], ...E[keyof E][]];

export default function getEnumValues<E extends Record<string, string | number>>(
    e: E,
): EnumValues<E> {
    const values = Object.values(e);
    const isNumberBased = values.filter(isNumber).length === values.filter(isString).length;
    const isStringBased = !values.some((v) => typeof v === "number");
    if (isNumberBased) {
        return values.filter(isNumber) as EnumValues<E>;
    } else if (isStringBased) {
        return values as EnumValues<E>;
    } else {
        throw new Error("Enum is mixed, can't handle it");
    }
}
